/*
 * Copyright (c) CIRROM 2026.
 */

import React from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import {
  confidenceSwatchColor,
  getConfidenceBand,
} from "./helpers/confidenceBands";
import classes from "./css/recordReview.module.css";

/*
 * Confidence as the product's own instrument.
 */
export const ConfidenceBand = (props: { confidence: number }) => {
  const band = getConfidenceBand(props.confidence);
  const rounded = Math.round(props.confidence);

  return (
    <Tooltip
      title={`Cirrom's confidence in this value: ${rounded} out of 100 — ${band.label.toLowerCase()}`}
    >
      <div className={classes.confidence}>
        <Box
          aria-hidden="true"
          className={classes.confidenceSwatch}
          sx={{ backgroundColor: confidenceSwatchColor(props.confidence) }}
        />
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
          {band.label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", whiteSpace: "nowrap" }}
        >
          {rounded}%
        </Typography>
      </div>
    </Tooltip>
  );
};
